const createUploadSessionId = (): string =>
  globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const getOrCreateUploadSessionId = (storageKey: string): string => {
  const existing = sessionStorage.getItem(storageKey);
  if (existing) return existing;
  const id = createUploadSessionId();
  sessionStorage.setItem(storageKey, id);
  return id;
};

export const resetUploadSessionId = (storageKey: string): string => {
  const id = createUploadSessionId();
  sessionStorage.setItem(storageKey, id);
  return id;
};

export const clearUploadSessionId = (storageKey: string): void => {
  sessionStorage.removeItem(storageKey);
};

export const BILL_UPLOAD_SESSION_KEY = 'purchases-manage-upload-session';
export const INVOICE_UPLOAD_SESSION_KEY = 'sales-manage-upload-session';
export const CUSTOMER_PAYMENT_UPLOAD_SESSION_KEY = 'receive-payments-upload-session';
export const BILL_PAYMENT_UPLOAD_SESSION_KEY = 'pay-bills-upload-session';
